export const PageNumberOptions = ({ numItems }) => {
    return [...Array(numItems)].map((x, index) => (
        <option key={index} value={index + 1}>
            {index + 1}
        </option>
    ));
};
